import { Box, Checkbox, Drawer, FormControlLabel, Grid2, Icon, IconButton, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Link, useParams } from "react-router-dom";
import { TicketTypeEnum } from "../../_common/enum/ticketType.enum";
import EnumSelect from "../../_components/autocomplete/enum.select";
import { StandardButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { closingChecklistService } from "../../_services/closingChecklist.service";
import { dropdownService } from "../../_services/dropdown.service";
import { DataTypeEnum } from "../../_common/enum/dataType.enum";
import { ClosingChecklistListTypeEnum } from "../../_common/enum/closingChecklistListType.enum";
import { StandardList } from "../../_components/list/standardList.component";
import { StandardListItem } from "../../_components/list/standardListItem.component";


export const ClosingChecklistManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {

    const resetData = () => ({});

    const { id } = useParams<{ id: string }>();

    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [closingChecklistTypes, setClosingChecklistTypes] = useState<any[]>([]);
    const [selectedChecklistTypeIds, setSelectedChecklistTypeIds] = useState<number[]>([]);


    useEffect(() => {
        fetchClosingChecklistTypes();

        if (id != null)
            fetchData();
        else
            setData(resetData);
    }, [id]);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    function fetchData() {
        if (!id) return;

        setIsLoading(true);
        return closingChecklistService
            .get(id)
            .then(
                (json) => {
                    setData(json);
                    const selectedIds = json.closingChecklistItems?.map((item: any) => item.closingChecklistTypeId) || [];
                    setSelectedChecklistTypeIds(selectedIds);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function fetchClosingChecklistTypes() {
        return dropdownService.fetchData(DataTypeEnum.ClosingChecklistTypes)
            .then(
                (json) => {
                    setClosingChecklistTypes(json);
                }, handleErrorResponse
            );
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        const _data = {
            ...data,
            closingChecklistItems: selectedChecklistTypeIds.map((id, index) => {
                const type = closingChecklistTypes.find(t => t.id === id);
                const existingItem = data.closingChecklistItems?.find((item: any) => item.closingChecklistTypeId === id);

                const _item: any = {
                    id: existingItem?.id,
                    closingChecklistTypeId: id,
                    name: type?.name || "",
                    itemOrder: existingItem?.itemOrder ?? (index + 1)
                };

                // Only add id if editing
                if (existingItem?.id != null) {
                    _item.id = existingItem.id;
                }

                return _item;
            })
        };

        return closingChecklistService
            .submit(_data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    resetData();
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function disable() {
        if (!id) return;
        setIsLoading(true);
        return closingChecklistService
            .disable(id)
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    const handleCheckboxToggle = (typeId: number) => {
        setSelectedChecklistTypeIds((_data) =>
            _data.includes(typeId)
                ? _data.filter(id => id !== typeId)
                : [..._data, typeId]
        );
    };

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={(!!id) ? "Update Closing Checklist" : "Create Closing Checklist"} onClose={params.onClose} />

            <ValidatorForm
                onSubmit={submit}
                noValidate>

                <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="name"
                            name="name"
                            label="Name"
                            required
                            fullWidth
                            validators={['required', 'minStringLength:1']}
                            errorMessages={['required field', "Field cannot be empty"]}
                            value={data.name}
                            onChange={handleChange}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <EnumSelect
                            enumObject={TicketTypeEnum}
                            label="Select Ticket Type"
                            name="ticketTypeId"
                            value={data.ticketTypeId}
                            onChange={handleChange}
                            required />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <EnumSelect
                            key="closingChecklistListTypeId"
                            enumObject={ClosingChecklistListTypeEnum}
                            label="Select List Type"
                            name="closingChecklistListTypeId"
                            value={data.closingChecklistListTypeId}
                            onChange={handleChange}
                            required
                            fullWidth
                        />
                    </Grid2>

                    {/*<Grid2 container spacing={2} mt={1}>
                        {closingChecklistTypes.map((item, index) => (
                            <Grid2 size={{ xs: 12 }} key={index}>
                                <Paper
                                    elevation={1}
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        borderRadius: 2,
                                        backgroundColor: '#f9f9f9',
                                        '&:hover': {
                                            backgroundColor: '#f1f1f1',
                                        },
                                    }}
                                >
                                    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                        <Typography variant="body1">{item.name}</Typography>
                                        <Checkbox
                                            checked={selectedChecklistTypeIds.includes(item.id)}
                                            onChange={() => handleCheckboxToggle(item.id)}
                                        />
                                    </Box>
                                </Paper>
                            </Grid2>

                        ))}
                    </Grid2>*/}
                    <Grid2 display="flex" justifyContent="flex-start">
                        <Typography variant="h6" mt={2}> Select List Item </Typography>
                    </Grid2>

                    <StandardList isLoading={isLoading}>
                        {!isLoading && closingChecklistTypes.map((item: any, index: number) => (
                            <StandardListItem
                                primary={item.name}
                                tertiary={
                                    <Checkbox
                                        checked={selectedChecklistTypeIds.includes(item.id)}
                                        onChange={() => handleCheckboxToggle(item.id)}
                                    />
                                }
                                key={item.id}

                            />
                        ))}

                    </StandardList>

                    <Grid2 size={{ xs: 12 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: data.id == null ? 12 : data?.isActive === false ? 12 : 6 }}>
                                <StandardButton
                                    saving={saving}
                                    loading={isLoading}
                                    icon="save"
                                    type="submit">
                                    {(data?.isActive === false) ? "Save and Reactivate" : "Save"}
                                </StandardButton>
                            </Grid2>

                            {(!!id && data?.isActive === true) &&
                                <Grid2 size={{ xs: 6 }}>
                                    <StandardButton
                                        saving={saving}
                                        loading={isLoading}
                                        icon="block"
                                        variant="error"
                                        onClick={disable}>
                                        Disable
                                    </StandardButton>
                                </Grid2>
                            }
                        </Grid2>
                    </Grid2>
                </Grid2>

            </ValidatorForm>
        </Drawer>
    );
};